import type { ResultadoDeInvitacion } from '../servicios/api'

/**
 * #149 · El resultado de una invitación dicho para quien invita. `aviso` confirma lo que ya
 * quedó y cabe en un aviso que se desvanece; `pendiente` es lo que quien invita tiene que hacer
 * para que la persona entre, y por eso se queda en pantalla hasta que lo descarte.
 *
 * La comparten la invitación, su reenvío y el alta de un despacho en la consola de plataforma.
 */
export function explicarInvitacion(
  correo: string,
  r: ResultadoDeInvitacion,
): { aviso: string | null; pendiente: string | null } {
  const sinCorreo = `No se pudo enviar el correo a ${correo}. La invitación sigue vigente: avísale por otro medio`

  switch (r.cuenta) {
    case 'Creada':
      // La contraseña temporal solo viajó en ese correo y no se guarda en ningún lado.
      return r.correoEnviado
        ? { aviso: `Invitación enviada a ${correo}: su cuenta quedó creada y el correo lleva su contraseña temporal.`, pendiente: null }
        : {
            aviso: null,
            pendiente: `La cuenta de ${correo} quedó creada, pero el correo con su contraseña temporal no salió, y esa ` +
              'contraseña no se guarda en ningún lado. Pídele que entre con su correo y elija «¿Olvidaste tu contraseña?» ' +
              'para poner una suya.',
          }
    case 'YaExistia':
    case 'Reactivada':
      return r.correoEnviado
        ? { aviso: `Invitación enviada a ${correo}: ya tenía cuenta y entra con su contraseña de siempre.`, pendiente: null }
        : { aviso: null, pendiente: `${sinCorreo} que ya puede entrar con su contraseña de siempre.` }
    case 'NoConfigurado':
      return {
        aviso: r.correoEnviado ? `Invitación enviada a ${correo}.` : null,
        pendiente: [r.correoEnviado ? null : `${sinCorreo}.`, r.problemaDeCuenta].filter(Boolean).join(' '),
      }
    case 'Error':
      return { aviso: null, pendiente: r.problemaDeCuenta }
  }
}
